import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import { AuthEffects } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.effects'
import { FrontState } from 'libs/gb-front/core/data-access/src/lib/+state/front-state.models'
import { hydrationMetaReducer } from 'libs/shared/hydration/src/lib/+state/hydration.reducer'
import { HydrationEffects } from 'libs/shared/hydration/src/lib/+state/hydration.effects'
import * as fromAuctionReducer from 'libs/gb-front/auction/data-access/src/lib/+state/auction.reducer'
import { AuctionEffects } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.effects'
import * as fromItemReducer from 'libs/gb-front/item/data-access/src/lib/+state/items.reducer'
import * as fromProfileReducer from 'libs/gb-front/profile/data-access/src/lib/+state/profiles.reducer'
import { ProfilesEffects } from 'libs/gb-front/profile/data-access/src/lib/+state/profiles.effects'
import * as fromAuthReducer from 'libs/gb-front/auth/data-access/src/lib/+state/auth.reducer'
import { AuthVerifyEffects } from 'libs/gb-front/auth/data-access/src/lib/+state/auth-verify.effects'
import * as fromSelectedProfileReducer from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.reducer'
import { SelectedProfileEffects } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.effects'
import * as fromSelectedItemReducer from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.reducer'
import * as fromProfileItemActivitiesReducer from 'libs/gb-front/item/data-access-profile-item-activities/src/lib/+state/profile-item-activities.reducer'
import * as fromEventTicketPackagesReducer from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.reducer'
import { SELECTED_ITEM_EFFECTS } from 'libs/gb-front/selected-item/data-access/src/lib/gb-front-selected-item-data-access.module'
import { EventTicketPackagesEffects } from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.effects'
import { EventTicketPurchasesEffects } from 'libs/gb-front/event-tickets/data-access-event-ticket-purchases/src/lib/+state/event-ticket-purchases.effects'
import * as fromEventTicketPurchasesReducer from 'libs/gb-front/event-tickets/data-access-event-ticket-purchases/src/lib/+state/event-ticket-purchases.reducer'
import * as fromEventTicketPackageProfileActivitiesReducer from 'libs/gb-front/event-tickets/data-access-event-ticket-package-profile-activities/src/lib/+state/event-ticket-package-profile-activities.reducer'
import { EventTicketPackageProfileActivitiesEffects } from 'libs/gb-front/event-tickets/data-access-event-ticket-package-profile-activities/src/lib/+state/event-ticket-package-profile-activities.effects'
import { EventTicketsEffects } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.effects'
import { GoogleAnalyticsEffects } from 'libs/shared/google-analytics/src/lib/+state/google-analytics.effects'
import * as fromEventTicketsReducer from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.reducer'

// TODO (GB-6338): Update to only basic state app needs (i.e. auction and authentication)
export const appReducers: ActionReducerMap<FrontState> = {
  auction: fromAuctionReducer.reducer,
  items: fromItemReducer.reducer,
  selectedItem: fromSelectedItemReducer.reducer,
  profiles: fromProfileReducer.reducer,
  selectedProfile: fromSelectedProfileReducer.reducer,
  authentication: fromAuthReducer.reducer,
  profileItemActivities: fromProfileItemActivitiesReducer.reducer,
  eventTicketPackages: fromEventTicketPackagesReducer.reducer,
  eventTicketPurchases: fromEventTicketPurchasesReducer.reducer,
  eventTicketPackageProfileActivities: fromEventTicketPackageProfileActivitiesReducer.reducer,
  eventTickets: fromEventTicketsReducer.reducer,
}

export const appMetaReducers: MetaReducer[] = [hydrationMetaReducer]

export const appEffects = [
  AuctionEffects,
  ProfilesEffects,
  SelectedProfileEffects,
  AuthEffects,
  AuthVerifyEffects,
  HydrationEffects,
  EventTicketPackagesEffects,
  EventTicketPurchasesEffects,
  EventTicketPackageProfileActivitiesEffects,
  EventTicketsEffects,
  ...SELECTED_ITEM_EFFECTS,
  GoogleAnalyticsEffects,
]
